var chunkToChildrenMap = {
	"5369": [
		2963,
		2831,
		3706,
		4161,
		8635,
		5242
	],
	"5626": [
		2963,
		3706,
		4161,
		5903
	],
	"9175": [
		2963,
		3706,
		4161,
		5903
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };